import makeStruct from "@helper/makeStruct";
import { joinLocalKeys, makeRootLocalKey } from "@services/localization";

export default function makePssError(name) {
  return makeStruct(name, ["data", "errorKey", "localKey"], {
    defaults: {
      data: {},
      errorKey: null,
      localKey: makeRootLocalKey(joinLocalKeys("PSS", name)),
    },
    static: { isPssError: true },
  });
}
